<div *ngIf="selectedTab$ | async as selectedTab" class="tabs-wrap">
	@for(tab of tabInfo; track tab.id) {
		<div *ngIf="tab.visible !== false" (click)="onTabClicked(tab)" [class]="getTabClass(tab, selectedTab)">
			<i [class]="tab.icon"></i>{{tab.text}}
		</div>
	}
</div>
